import { render, staticRenderFns } from "./RejectionTemplateChooser.vue?vue&type=template&id=835e4534"
import script from "./RejectionTemplateChooser.vue?vue&type=script&lang=js"
export * from "./RejectionTemplateChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports